<template>
    <Popup ref="popup" :animation="'scale'" >
        <div class="tip-cont" >
            <div class="tip-content t-c" >
                <span class="fs-2 segoe" >{{ tip }}</span>
            </div>
            <div class="btns" >
                <div class="btn confirm t-c" @click.stop="close" >
                    <span class="fs-2 fb segoe" >{{ $t("message.okay") }}</span>
                </div>
            </div>
        </div>
    </Popup>
</template>

<script>
import Popup from '../Popup.vue';
export default {
    data() {
        return {
            tip: ''
        }
    },
    methods: {
        show(tip) {
            this.tip = tip;
            this.$refs.popup.show();
        },
        close() {
            this.$refs.popup.hide();
        }
    },
    components: { Popup }
}
</script>

<style lang="scss" >
@import "../../assets/css/variables.scss";
.tip-cont {
    width: 36rem;
    height: 24rem;
    background: url($assetRoot + "/popup_bg.png") center no-repeat;
    background-size: 100% 100%;
    margin: 0 auto;
    box-sizing: border-box;
    padding: 4rem 2rem;

    span {
        color: #FFF;
    }

    .tip-content {
        height: 13.2rem;
    }

    .btns {

        .btn {
            display: inline-block;
            width: 13rem;
            height: 5rem;
            line-height: 4.6rem;
        }

        .confirm {
            background: url($assetRoot + "/button_yes.png") center no-repeat;
            background-size: 100% 100%;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/popup/Tip.vue